import React, { useState } from "react";
import { Formik } from "formik";
import * as Yup from "yup";
import Controls from "../components/FormsUI";
import { useAuth } from "../utility/auth";
import AddressController from "../controller/AddressController";
import MastersController from "../controller/MastersController";
import CustomizedSnackbars from "../components/Alert";
import "../css/style.css";
import { tokens } from "../theme";
import Load from "../components/FormsUI/Loader/index";
import { Container, Grid, useTheme, Box } from "@mui/material";
import ExceptionHandlerController from "../controller/ErrorLogsController";
const numberRegEx = /^[0-9\b]+$/;
const INITIAL_FORM_STATE = {
  name: "",
  address: "",
  pin: "",
  state: "",
  telephone: "",
};

const FORM_VALIDATION = Yup.object().shape({
  name: Yup.string()
    .trim("No white space allowed")
    .strict(true)
    .max(50)
    .required("Name is required"),
  address: Yup.string()
    .trim("No white space allowed")
    .strict(true)
    .required("Address is required"),
  pin: Yup.string()
    .trim("No white space allowed")
    .strict(true)
    .required("Pin is required"),
  telephone: Yup.string()
    .trim("No white space allowed")
    .strict(true)
    .required("Telephone is required"),
});
const addressController = new AddressController();
const exceptionHandlerController = new ExceptionHandlerController();

const AddressDetails = () => {
  const auth = useAuth();
  const user = auth.decoder(sessionStorage.getItem("user"));
  const [alert, setAlert] = useState({ counter: 0, type: "", msg: "" });
  const { data, token } = user;
  const theme = useTheme();
  const mastersController = new MastersController();
  // const { userid: tenantId } = data.UserInfo;
  const { userid: userId, tenantid: tenantId } = data.UserInfo;
  const [addressId, setAddressId] = useState("");
  const [updatedValues, setUpdatedValues] = useState(INITIAL_FORM_STATE);
  const [numberMinMax, setNumberMinMax] = useState({ pin: "", telephone: "" });
  const [pincodeData, setPincodeData] = useState({
    state: "",
    city: "",
    country: "",
  });
  const colors = tokens(theme.palette.mode);
  const [loader, setLoader] = useState(false);

  React.useEffect(() => {
    let caughtError;
    try {
      //fetching bank masters for dropdown options
      const GetAddress = () => {
        addressController
          .Get(tenantId, token)
          .then((resultObj) => {
            setLoader(() => false);
            if (resultObj?.status === 200) {
              const responsedata = resultObj?.data?.body;
              setPincodeData({
                state: responsedata?.state,
                city: responsedata?.city,
                country: responsedata?.country,
              });
              setUpdatedValues(responsedata);
              setNumberMinMax((prev) => ({
                ...prev,
                pin: responsedata?.pin ?? "",
                telephone: responsedata?.telephone ?? "",
              }));
              setAddressId(responsedata?.addressId);
            }
          })
          .catch((error) => {
            caughtError = error;
            let logData = {};
            logData.message = caughtError?.message;
            logData.stack = caughtError?.stack;
            let logError = { logData, module: "Address details page Get method" };
            exceptionHandlerController.HandleException(logError);
          });
      };
      GetAddress();
    } catch (error) {
      caughtError = error;
      let logData = {};
      logData.message = caughtError?.message;
      logData.stack = caughtError?.stack;
      let logError = { logData, module: "bank details page Get method" };
      exceptionHandlerController.HandleException(logError);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const getLocation = (pincode) => {
    mastersController.GetLocation({ pincode }).then((result) => {
      if (result?.status === 200) {
        const fetchedLocation = result?.data?.body?.pincode;
        setPincodeData({
          state: fetchedLocation?.state,
          city: fetchedLocation?.city,
          country: fetchedLocation?.countryCode,
        });
      } else {
        setPincodeData({});
        showAlert("error", "Invalid Pincode. Please Re-enter Pincode.");
      }
    });
  };

  const showAlert = (type, msg) => {
    const notify = { ...alert };
    notify.counter = notify.counter + 1;
    notify.type = type;
    notify.msg = msg;
    setAlert(notify);
  };
  const submitValues = async (values) => {
    try {
      // Set common values
      setCommonValues(values);

      // Validate fields
      if (!validateFields(values)) return;

      // Submit the address
      if (!addressId) {
        await createAddress(values);
      } else {
        await updateAddress(values);
      }
    } catch (error) {
      handleError(error);
    }
  };

  const setCommonValues = (values) => {
    values.tenantId = tenantId;
    values.state = pincodeData?.state ?? "";
    values.city = pincodeData?.city ?? "";
    values.country = pincodeData?.country ?? "";
  };

  const validateFields = (values) => {
    if (!values.state || !values.city || !values.country) {
      showAlert("error", "All Fields are required");
      return false;
    }
    values.pin = values?.pin ?? "";
    return true;
  };

  const createAddress = async (values) => {
    try {
      const response = await addressController.Create(values, token);
      if (response?.data?.status === 201) {
        setAddressId(response?.data?.body?.addressId);
        showAlert("success", response?.data?.message);
      } else {
        showAlert("error", response?.response?.data?.message);
      }
    } catch (error) {
      showAlert("error", "Oops something went wrong.");
    }
  };

  const updateAddress = async (values) => {
    values.addressId = addressId;
    try {
      const response = await addressController.Update(values, token);
      if (response?.data?.status === 200) {
        showAlert("success", response?.data.message);
      } else {
        showAlert("error", response?.response?.data?.message);
      }
    } catch (error) {
      showAlert("error", "Oops something went wrong.");
    }
  };

  const handleError = (error) => {
    const logData = {
      message: error?.message,
      stack: error?.stack,
    };
    const logError = {
      logData,
      module: "bank details page submit method",
    };
    exceptionHandlerController.HandleException(logError);
  };

  if (loader) return <Load />;
  return (
    <div className="main-content">
      <Box
        sx={{
          "& .formBg": {
            border: `1px solid ${colors.grey[900]}`,
            background: `${colors.primary[400]}`,
          },
          "& li.MuiBreadcrumbs-li h6": { color: `${colors.primary[200]}` },
          "& .MuiGrid-root.Mui-heading h2": {
            color: `${colors.primary[200]} !important`,
          },
        }}
      >
        <Grid container>
          <Grid className="breadcrumb-section">
            <Grid className="breadcrumb-container">
              <Grid className="Mui-li">
                <nav className="Mui-nav" aria-label="breadcrumb">
                  <ol className="">
                    <li className="MuiBreadcrumbs-li">
                      <h6 className="breadsub">Home</h6>
                    </li>
                    <li aria-hidden="true" className="MuiBreadcrumbs-separator">
                      /
                    </li>
                    <li className="MuiBreadcrumbs-li">
                      <h6>Address Details</h6>
                    </li>
                  </ol>
                </nav>
              </Grid>
            </Grid>
          </Grid>

          <Grid item xs={12} className="formBg">
            <Container maxWidth="md" className="formClwidth">
              <div>
                <Formik
                  enableReinitialize
                  initialValues={{
                    ...(updatedValues || INITIAL_FORM_STATE),
                  }}
                  validationSchema={FORM_VALIDATION}
                  onSubmit={(values) => submitValues(values)}
                >
                  {({
                    setFieldValue,
                    handleChange,
                    handleBlur,
                    setFieldTouched,
                  }) => (
                    <Grid container spacing={2}>
                      <Grid item xs={12} md={6}>
                        <Controls.Textfield
                          name="name"
                          label="Name *"
                          type="string"
                          inputProps={{ maxLength: 50 }}
                        />
                      </Grid>
                      <Grid item xs={12} md={6}>
                        <Controls.Textfield
                          name="address"
                          label="Address *"
                          type="string"
                          inputProps={{ maxLength: 300 }}
                        />
                      </Grid>
                      <Grid item xs={12} md={6}>
                        <Controls.Textfield
                          name="pin"
                          label="Pin *"
                          type="string"
                          onBlur={(e) => {
                            setFieldTouched("pin", true, true);
                            const { value } = e.target;
                            if (value?.length === 6) {
                              getLocation(Number(value));
                            }
                            handleBlur(e);
                          }}
                          inputProps={{ maxLength: 6 }}
                          value={numberMinMax.pin || ""}
                          onChange={(e) => {
                            const { value } = e.target;
                            if (numberRegEx.test(value) || value === "") {
                              setNumberMinMax((prev) => ({
                                ...prev,
                                pin: value,
                              }));
                              setFieldValue("pin", value);
                              setFieldTouched("pin", true, true);
                            }
                            handleChange(e);
                          }}
                        />
                      </Grid>
                      <Grid item xs={12} md={6}>
                        <Controls.Textfield
                          name="city"
                          label="City *"
                          disabled={true}
                          value={pincodeData?.city || ""}
                          type="string"
                        />
                      </Grid>
                      <Grid item xs={12} md={6}>
                        <Controls.Textfield
                          name="state"
                          label="State *"
                          type="string"
                          disabled={true}
                          value={pincodeData?.state || ""}
                        />
                      </Grid>
                      <Grid item xs={12} md={6}>
                        <Controls.Textfield
                          name="country"
                          label="Country *"
                          type="string"
                          disabled={true}
                          value={
                            (pincodeData?.country === "IND"
                              ? "INDIA"
                              : pincodeData?.country) || ""
                          }
                        />
                      </Grid>
                      <Grid item xs={12} md={6}>
                        <Controls.Textfield
                          name="telephone"
                          label="Telephone *"
                          type="string"
                          value={numberMinMax.telephone || ""}
                          inputProps={{ maxLength: 12 }}
                          onChange={(event) => {
                            const { value } = event?.target;
                            if (numberRegEx.test(value) || value === "") {
                              setNumberMinMax((prev) => ({
                                ...prev,
                                telephone: value,
                              }));
                              setFieldValue("telephone", value);
                            }
                          }}
                        />
                      </Grid>

                      <Grid item xs={12}>
                        <Grid item xs={4} md={2} className="marginAuto">
                          <Controls.Button>Submit</Controls.Button>
                        </Grid>
                      </Grid>
                    </Grid>
                  )}
                </Formik>
                {alert.counter > 0 && (
                  <CustomizedSnackbars
                    status={alert.counter}
                    msg={alert.msg}
                    type={alert.type}
                  />
                )}
              </div>
            </Container>
          </Grid>
        </Grid>
      </Box>
    </div>
  );
};

export default AddressDetails;
